module.exports = __webpack_public_path__ + "img/empty_pic.85927bb6.png";